import { render, staticRenderFns } from "./leftCom.vue?vue&type=template&id=96cab082&scoped=true&"
import script from "./leftCom.vue?vue&type=script&lang=js&"
export * from "./leftCom.vue?vue&type=script&lang=js&"
import style0 from "./leftCom.vue?vue&type=style&index=0&id=96cab082&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96cab082",
  null
  
)

component.options.__file = "leftCom.vue"
export default component.exports